module.exports = __webpack_public_path__ + "img/basslake-portrait.7b50dce8.jpg";